export default {
  links: {
    home: '首頁',
    plans: '平面圖',
    interiors: '室內設計',
    neighbourhood: '社區介紹',
    amenities: '康娛設施',
    developer: '開發商',
    register: '搶先登記',
    contact: '聯絡方式',
  },

  // FOOTER
  footer: {
    getInTouch: '與我們聯繫',
    contactCopy:
      '<span>歡迎向我們詢問關於<br/>Ivy on The Park的詳細資訊</span>',
    email: 'info@ivyonthepark.com',
    presentationCentre: '展銷中心',
    tel: '電話: ',
    telNumber: '604-225-0117',
    address:
      '卑詩大學 Wesbrook Village Gray 路 5898 號',
    managedBy: 'Managed By',
    marketedBy: 'Marketed By',
    disclaimer:
      'THIS IS NOT AN OFFERING FOR SALE. ANY SUCH OFFERING CAN ONLY BE MADE BY WAY OF DISCLOSURE STATEMENT. E.& O.E.',
  },

  // HOME
  home: {
    title: `
      <span>
       令人嚮往的 POINT GREY 生活
      </span>
    `,
    subtitle: '| 城市生活與自然美景的完美結合 |',
    copy: `Ivy on the Park 位於溫哥華最卓越的地點，融合天然美景與人文色彩，是罕見的傑出社區。
    坐落溫哥華西區的 Wesbrook Village，Ivy on the Park 坐擁各種便利，周圍被許多休閒設施、世界名校、
    公園綠地、海灘與森林環繞，您將能在此享受前所未有的高雅生活，擁抱城市便利與自然景觀。`,
    registerBtn: '即刻登記',
    cards: [
      {
        title: '多樣化的住宅選擇',
        subtitle: '多元戶型',
        learnMore: '觀看戶型圖',
      },
      {
        title: '功能齊全的美食廚房',
        subtitle: '讓烹飪成為一種享受',
        learnMore: '了解更多',
      },
      {
        title: '無以倫比的絕佳地點',
        subtitle: '卓越社區',
        learnMore: '了解更多',
      },
      {
        title: '精彩絕倫的休閒生活',
        subtitle: '康娛設施',
        learnMore: '了解更多',
      },
      {
        title: 'The Wall 企業集團',
        subtitle: '開發商',
        learnMore: '了解更多',
      },
    ],
    register: '即刻登記',
  },

  // PLANS
  plans: {
    heading: `多樣化的住宅選擇`,
    types: ['華廈', '中層豪邸', '聯排別墅'],
    filters: ['套房', '1 臥', '2 臥', '2 臥 + 書房', '3 臥', '3 臥 + 書房'],
    plan: '戶型圖',
    studio: '套房',
    bed: '臥房',
    bath: '衛浴間',
    den: '書房',
    sqft: '平方尺',
    interior: '室內空間',
    exterior: '戶外空間',
    download: '下載戶型圖',
  },

  // INTERIORS
  interiors: {
    title: '尊貴低調的極致高雅',
    subtitle: '室內設計',
    copy: `Ivy on the Park 的室內設計，靈感源自於其現代化的建築外觀，以及綠意盎然的西岸天然美景。
    整體空間以溫暖舒適的色調與材質為主軸，與 UBC 的自然景觀相互輝映；從意式櫥櫃、精心規劃的主臥衛浴
    到實木地板等各項配備，在在體現豪華生活的尊貴本質，絕對令人愛不釋手。`,
    captions: ['起居室', '聯排別墅室內設計'],
    featuresFinishes: '配套與裝潢',
    downloadBtn: '下載 PDF',
    features: [
      {
        title: '卓越生活',
        list: [
          '開放式設計，以特大窗戶引入充足自然光',
          '兩種優美的主題色調可供選擇',
          '所有戶型皆鋪設精美的白橡實木地板',
          '可調整的鍍鉻崁燈與步入式衣櫥，營造無與倫比的典雅氣氛',
          '洗衣房內配備光滑石質檯面、定製收納空間，Blomberg 前置式洗衣機與電動排氣烘衣機',
          '配備提供舒適溫度的室內空調系統',
        ],
      },
      {
        title: '美食廚房',
        list: [
          '光滑石質檯面提供寬敞備料空間，與以霧面磁磚打造而成的防濺水牆相互輝映',
          '高端Bosch家電套裝，內含：',
          [
            '配有定製面板的 30 寸下置冷凍室冰箱',
            '30 寸不銹鋼快速烤箱',
            '30 寸不銹鋼快速烤箱',
            '30 寸不銹鋼入牆式烤箱和置頂式抽油煙機',
            '安裝定製面板的 24 寸洗碗機',
          ],
          '限量尊貴豪邸配有 Thermador 18 寸莰入式葡萄酒冰櫃',
          '配備關門緩衝機制與一體成形握把的橡木面板意式櫥櫃，可整齊地收納各種廚房用具',
          '下莰式雙水槽，搭配拋光鍍鉻的 Kohler 抽拉龍頭',
          '櫥櫃下裝設鍍鉻 LED 照明設施，以柔和光線照亮廚房空間',
          '1⁄2 匹馬力的廚餘處理機，令清潔工作變得更加輕鬆',
          '設有 USB 充電插頭的無螺絲 Adorne 插座',
        ],
      },
      {
        title: '尊爵衛浴',
        list: [
          '衛生間與主臥衛浴套間均鋪設大片瓷磚',
          '衛生間與主臥衛浴套間均裝設光滑石英檯面',
          '以無框玻璃隔出的寬敞淋浴空間，牆面、底部鋪設大片霧面瓷磚，側邊則鋪設石英磚',
          '主臥衛浴套間配備顯眼的 Kohler Rite-Temp 穩壓淋浴組，以及定製收納架',
          '主臥衛浴套間的裝設背光化妝鏡，整理容貌時不需擔心光線問題',
          '裝設 Hytec 壓克力浴缸，搭配壁莰式 Kohler Purist Rite-Temp 穩壓鍍鉻淋浴頭',
          '裝設 Kohler 下莰式循環水槽，搭配拋光鍍鉻的 Purist Collection 龍頭組',
        ],
      },
      {
        title: '露台特色',
        list: [
          '飽覽 Pacific Spirit 公園與喬治亞峽灣的壯麗景色',
          '鋪設品質優異、不易腐爛、蟲蛀、褪色、龜裂或發霉的複合木地板（包含 95% 回收質材），僅需以肥皂水清洗即可保持清潔',
          '3 臥房、空中豪宅與所有聯排別墅等戶型設有兩個天然氣接口，可輕鬆在安裝燒烤爐、暖氣或天然氣暖爐，讓您可隨時享受戶外生活',
        ],
      },
      {
        title: '精彩生活',
        list: [
          '大型健身中心和瑜伽教室，為您打造健康的身心靈體態',
          '靜瑟的圖書館能讓您專心於課業或工作',
          '配有鋼琴和座椅的音樂沙龍，以及專屬音樂室，能讓您與賓客一起享受美好音樂',
          '可供個人與團體使用的工作及學習室',
          '精心規劃的休閒會所，並可通往位於戶外的社區花園',
          '精心規劃的戶外花園',
          'National Home Warranty 新屋質保',
        ],
      },
      {
        title: '社區休閒',
        list: [
          '位於尊貴的 Wesbrook Mall 社區，毗鄰 UBC 的人文學術核心',
          '許多商店、超級市場、餐廳、咖啡廳與提供各種服務的店家均近在咫尺',
          '各類適合全家大小共同參與的社區活動',
          '鄰近許多學校、社區中心與奧林匹克級的運動設施，提供適合各種年紀的休閒與教育活動',
          '與 Pacific Spirit 公園比肩，綠意盎然的森林步道、適合蹓狗的小徑、小溪和海灘應有盡有',
          '坐擁四通八達的交通與公交網絡，可輕鬆前往溫哥華市中心和國際機場',
        ],
      },
    ],
  },

  // NEIGHBOURHOOD
  neighbourhood: {
    title: '無以倫比的絕佳地點',
    subtitle: '卓越社區',
    copy: `Ivy on the Park 坐落於絕佳地段，鄰近許多深受歡迎的國際名校、知名社區與景點，
    能同時擁抱絕佳美景與便利生活。 Wesbrook Village 內的眾多商店能滿足一切生活所需，周邊的公園、
    社區以及如同小型城市般的 UBC 校區，更能讓您享受多元有趣的各種活動。`,
    sections: [
      {
        title: 'Wesbrook Village',
        subtitle: '探索與購物',
        copy: `居住在 Ivy on the Park 將享有許多好處，例如可獲得大學社區協會
        （university neighbourhoods association，UNA）的會員資格，持 UNA 會員卡，
        將可進入 UBC 圖書館、溫哥華公眾圖書館、UBC 植物園、Nitobe 日本花園與人類學博物館，
        也能購買優惠門票進入 UBC 體育休閒中心與其他設施。`,
      },
      {
        title: '文化饗宴',
        subtitle: '沈浸於藝術中的非凡生活',
        copy: `正所謂「近朱者赤、近墨者黑」，選擇越卓越的生活環境，當然就能享受與眾不同的非凡生活。
        Ivy on the Park 與 UBC 毗鄰，這裡將是您最大的休閒場地，例如到陳氏表演藝術中心，聆聽歌劇、
        演唱會或觀賞藝術活動，當然也可到校區內的博物館觀賞展演。各類充滿人文藝術氣息的活動，都與您的住所僅一步之遙。`,
      },
      {
        title: '被名校環繞的出色環境',
        copy: `位於溫哥華西區的 Ivy on the Park，被許多國際知名的公私立學校環繞，包含幼兒園、小學、大學
        以及卑詩省排行前 20 名的多間中學，居住於此，將能為下一代提供絕佳的學習環境。`,
      },
    ],
    map: {
      exercise: '運動與健康',
      culture: '文化與學習',
      eat: '美食饗宴',
      shops: '購物與服務',
      schools: '學習與教育',
    },
  },

  // AMENITIES
  amenities: {
    title: '無比尊榮的迎賓大堂',
    subtitle: '康娛設施',
    copy: `Ivy on the Park 的迎賓大堂外，氣派的車道令您返回家中時感到無比尊貴，
    車道四周美麗的景觀設計，靈感源自於西岸特有的天然美景，與大堂內精心規劃的燈光與燦爛的
    大型吊燈互相輝映，更彰顯大堂內部，以長形暖爐為主、搭配舒適座位之現代化細部設計。`,
    sections: [
      {
        title: '與生活環環相扣',
        subtitle: '伴您成長的舒適空間',
        copy: `Ivy on the Park 坐擁許多室內外休閒設施，能帶給您多采多姿的生活。
        在圖書館裡，您可以安靜的工作或學習，也可與客戶和夥伴在大會議室內一起開會。
        此外，還能在音樂室內練習樂器，或邀請三五好友至音樂沙龍內享受您以鋼琴所演奏的美妙旋律。
        在忙於生活之餘，也能在健身中心與瑜伽教室內鍛鍊體魄，或至社區休閒會所或戶外花園和鄰居閒話家常。`,
        caption: '社交沙龍',
      },
    ],
  },

  // DEVELOPER
  developer: {
    title: 'The Wall 企業集團',
    subtitle: '開發商',
    copy: `<p>
        The Wall 企業集團曾經打造許多成功項目，因此擁有絕佳信譽。具有足夠自信，才能創造最有價值的投資。
        The Wall 的團隊曾在溫哥華參與數千宗住宅和酒店開發案，並且以這些經驗為基礎，採用最高標準
        傾力開發 Ivy on the Park，所有細節都鉅細彌遺。
      </p>
      <p>
        位於 UBC Wesbrook 社區的 Ivy on the Park，結合教育、藝術、人文及娛樂等元素，塑造前所未有的典雅生活，
        是無可比擬的投資機會。
      </p>`,
  },

  // REGISTER
  register: {
    title: '請即登記',
    subtitle: '索取最新信息',
    form: {
      firstName: '名字 *',
      lastName: '姓氏 *',
      email: '電郵 *',
      city: '城市 *',
      postal: '郵編 *',
      phone: '電話',
      realtor: '您是否為地產經紀？ *',
      hear: '您如何得知關於此一項目的信息？',
      hearOptions: [
        '廣告看板/路過',
        '親友介紹',
        '報紙廣告',
        '雜誌廣告',
        '社交網站',
        '地產經紀介紹',
        '線上廣告',
        '廣告單張',
        '其他',
      ],
      yes: '是',
      no: '否',
      consent: `請確認您願意接收來自 The Wall 企業集團和 Rennie 營銷系統的電子郵件，
      這些郵件將包含最新項目、貴賓預覽活動或其他的優惠信息。`,
      submit: '提交',
    },
  },

  // THANK YOU
  thankyou: {
    title: '感謝您在 IVY on the Park 完成登記',
    copy: `您將優先收到有關這個卓越項目的各種最新信息`,
    backBtn: '回到首頁',
  },
};



// WEBPACK FOOTER //
// ./src/config/locales/zh.js